import React from "react";
import "./Title.scss";

export default function Title({
    children,
    className = '',
    ...rest
}) {
    return (
        <h2 className={`title ${className}`} {...rest}>
            {children}
        </h2>
    );
}
